import { ACTION_ADD_CUSTOM_TAGS } from '../actionTypes';


export const actionAddCustomTags = customTags => ({
  type: ACTION_ADD_CUSTOM_TAGS,
  payload: { customTags },
});
